<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <input type="text" style="display:none"/>
        <input type="password" style="display:none"/>

        <!-- ROLE -->
        <FormItem prop="role" v-if="action === 'create'">
          <RadioGroup
            v-model="formData.role"
            type="button"
            size="large"
            style="margin-bottom: 10px;"
          >
            <!--<Radio label="manager"-->
            <!--&gt;<span style="margin: 0 30px 0 30px;font-size: 14px;"-->
            <!--&gt;УПРАВЛЯЮЩИЙ</span-->
            <!--&gt;</Radio-->
            <!--&gt;-->
            <Radio label="cashier"
            ><span style="margin: 0 20px 0 20px;font-size: 14px;"
            >Кассир</span
            ></Radio
            >
            <Radio label="storekeeper"
            ><span style="margin: 0 20px 0 20px;font-size: 14px;"
            >Кладовщик</span
            ></Radio
            >
          </RadioGroup>
        </FormItem>

        <!--&lt;!&ndash; LAST NAME | FIRST NAME | MIDDLE NAME &ndash;&gt;-->
        <!--<Row :gutter="16">-->
        <!--<Col span="8">-->
        <!--&lt;!&ndash; LAST NAME &ndash;&gt;-->
        <!--<FormItem prop="last_name" :label="schema.last_name.label">-->
        <!--<Input-->
        <!--v-model="formData.last_name"-->
        <!--:placeholder="schema.last_name.label"-->
        <!--/>-->
        <!--</FormItem>-->
        <!--</Col>-->
        <!--<Col span="8">-->
        <!--&lt;!&ndash; FIRST NAME &ndash;&gt;-->
        <!--<FormItem prop="first_name" :label="schema.first_name.label">-->
        <!--<Input-->
        <!--v-model="formData.first_name"-->
        <!--:placeholder="schema.first_name.label"-->
        <!--/>-->
        <!--</FormItem>-->
        <!--</Col>-->
        <!--<Col span="8">-->
        <!--&lt;!&ndash; MIDDLE NAME &ndash;&gt;-->
        <!--<FormItem prop="middle_name" :label="schema.middle_name.label">-->
        <!--<Input-->
        <!--v-model="formData.middle_name"-->
        <!--:placeholder="schema.middle_name.label"-->
        <!--/>-->
        <!--</FormItem>-->
        <!--</Col>-->
        <!--</Row>-->

        <Row class="mb-30">
          <Col :xs="24" :sm="24" :md="12" class="left__col">
            <!-- LAST NAME -->
            <FormItem prop="last_name" :label="schema.last_name.label">
              <Input
                v-model="formData.last_name"
                :placeholder="schema.last_name.label"
              />
            </FormItem>

            <!-- FIRST NAME -->
            <FormItem prop="first_name" :label="schema.first_name.label">
              <Input
                v-model="formData.first_name"
                :placeholder="schema.first_name.label"
              />
            </FormItem>

            <!-- MIDDLE NAME -->
            <FormItem prop="middle_name" :label="schema.middle_name.label">
              <Input
                v-model="formData.middle_name"
                :placeholder="schema.middle_name.label"
              />
            </FormItem>

            <!-- IMAGE -->
            <div v-if="formData.image_url" class="upload_image">
              <img :src="image_url_full" style="width: 110px; height: 110px; border-radius: 50%"/>
              <div class="upload_image_cover">
                <Icon type="ios-trash-outline" @click.native="deleteImage"></Icon>
              </div>
            </div>

            <Upload
              class="mb-30"
              v-else
              type="drag"
              :action="upload_url"
              :headers="{ Authorization: 'Bearer ' + token }"
              :on-success="onSuccessImageUpload"
            >
              <div style="padding: 20px 0">
                <Icon type="md-cloud-upload" size="50"/>
                <p>Загрузите изображение</p>
                <small>*Размер - 110*110px</small>
              </div>
            </Upload>

            <!-- STORES -->
            <Row v-if="formData.role === 'cashier' || formData.role === 'owner' " :gutter="16">
              <!--<Col span="12">-->
              <!--<FormItem-->
              <!--v-if="formData.role === 'cashier' || formData.role === 'storekeeper'"-->
              <!--prop="stores"-->
              <!--:label="schema.stores.label"-->
              <!--&gt;-->
              <!--<Select-->
              <!--v-model="formData.stores"-->
              <!--filterable-->
              <!--multiple-->
              <!--autocomplete="new-password"-->
              <!--&gt;-->
              <!--<Option-->
              <!--v-for="item in formSelectOptions.stores"-->
              <!--:value="item.id"-->
              <!--:key="item.id"-->
              <!--&gt;{{ item.name }}</Option-->
              <!--&gt;-->
              <!--</Select>-->
              <!--</FormItem>-->
              <!--</Col>-->
              <Col span="24">
                <FormItem
                  v-if="formData.role === 'cashier' || formData.role === 'owner'"
                  prop="cashes"
                  :label="schema.cashes.label"
                >
                  <Select
                    v-model="formData.cashes"
                    filterable
                    multiple
                  >
                    <Option
                      v-for="item in formSelectOptions.cashes"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}
                    </Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>

          </Col>
          <Col :xs="24" :sm="24" :md="12" class="right__col">
            <div v-if="formData.role === 'cashier' || formData.role === 'owner'">
              <FormItem prop="cashier_code" :label="schema.cashier_code.label">
                <InputNumber
                  style="width: 100%"
                  :min="0"
                  v-model="formData.cashier_code"
                  :placeholder="schema.cashier_code.label"
                ></InputNumber>
              </FormItem>

              <!-- MAX_AMOUNT -->
              <FormItem prop="max_amount" :label="schema.max_amount.label">
                <InputNumber
                  style="width: 100%"
                  :min="0"
                  v-model="formData.max_amount"
                  :placeholder="schema.max_amount.label"
                ></InputNumber>
              </FormItem>
            </div>

            <!-- PHONE -->
            <FormItem prop="phone" :label="schema.phone.label" v-if="action === 'create'">
              <Input
                v-model="formData.phone"
                :placeholder="schema.phone.label"
                v-mask="'+7(###) ###-##-##'"
              />
            </FormItem>

            <!-- EMAIL -->
            <FormItem prop="email" :label="schema.email.label">
              <Input
                v-model="formData.email"
                :placeholder="schema.email.label"
              />
            </FormItem>

            <div v-if="showCreatePassword">
              <!--  PASSWORD -->
              <FormItem
                prop="password"
                label="Пароль"
              >
                <Input
                  type="password"
                  v-model="formData.password"
                  placeholder="Введите пароль"
                  autocomplete="old-password"
                />
              </FormItem>

            </div>
          </Col>
        </Row>


        <!--&lt;!&ndash; EMAIL &ndash;&gt;-->
        <!--<FormItem prop="email" :label="schema.email.label">-->
        <!--<Input-->
        <!--type="hidden"-->
        <!--v-model="formData.email"-->
        <!--:placeholder="schema.email.label"-->
        <!--/>-->
        <!--</FormItem>-->


        <div v-if="action === 'edit'" align="center">
          <Button v-if="!showEditPassword" @click="showEditPassword = true"
                  style="box-shadow: none; border: none; color: #5087DE; text-decoration: underline"
          >Сменить пароль
          </Button
          >
          <Button v-if="showEditPassword" @click="showEditPassword = false"
                  style="box-shadow: none; border: none; color: #5087DE; text-decoration: underline"
          >Скрыть форму смены пароля
          </Button
          >
        </div>

        <div v-if="showChangePassword">
          <!-- OLD PASSWORD -->
          <FormItem
            prop="old_password"
            label="Старый пароль"
          >
            <Input
              type="password"
              v-model="formData.old_password"
              placeholder="Старый пароль"
              autocomplete="old-password"
            />
          </FormItem>

          <!-- NEW PASSWORD -->
          <FormItem
            prop="new_password"
            label="Новый пароль"
          >
            <Input
              type="password"
              v-model="formData.new_password"
              placeholder="Новый пароль"
              autocomplete="new-password"
            />
          </FormItem>
        </div>
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button type="error" style="margin-right: 8px" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button
        type="info"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      >
        <Icon type="md-checkmark"/>
      </Button>
    </div>
  </div>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import {base_url, server_addr} from "../../http.js";
    import {BaseFormData} from "../../base/base_form_v2.js";

    let _app = BaseFormData();

    _app.directives = {
        mask
    };
    _app.data = function () {
        return {
            loading: true,
            baseRules: {},
            excludeFieldsRules: [],
            validForm: false,
            isChanged: false,

            upload_url: base_url + "/user/upload/",

            formData: {
                role: "",
                last_name: "",
                first_name: "",
                middle_name: "",
                phone: "",
                email: "",
                password: "",
                old_password: "",
                new_password: "",
                // stores: [],
                cashier_code: null,
                max_amount: null,
                cashes: [],
                image: "",
                image_url: ""
            },

            formDefaultInitData: {
                role: "cashier",
                last_name: "",
                first_name: "",
                middle_name: "",
                phone: "",
                email: "",
                password: "",
                old_password: "",
                new_password: "",
                // stores: [],
                cashier_code: null,
                max_amount: null,
                cashes: [],
                image: "",
                image_url: ""
            },

            formSelectOptions: {
                // stores: [],
                cashes: []
            },

            showEditPassword: false,

            extraRules: {
              last_name: {
                required: true,
                message: "Введите корректное значение поля",
                trigger: "change"
              },
              first_name: {
                required: true,
                message: "Введите корректное значение поля",
                trigger: "change"
              },
                cashier_code: {
                    required: true,
                    // type: "number",
                    message: "Введите корректное значение поля (не более 4-х цифр)",
                    trigger: "change",
                    pattern: /^[0-9]{1,4}$/
                },
                max_amount: {
                    required: true,
                    type: "number",
                    message: "Введите корректное значение поля",
                    trigger: "change"
                },
                cashes: {
                    required: true,
                    type: "array",
                    message: "Выберите кассу",
                    trigger: "blur"
                },
                password: [
                  {
                    required: true,
                    // type: "number",
                    min: 5,
                    message: "Введите корректное значение поля (минимум 5 символов)",
                    trigger: "change"
                }],
                old_password: {
                    required: true,
                    // type: "number",
                    message: "Введите корректное значение поля",
                    trigger: "change"
                },
                new_password: {
                    required: true,
                    // type: "number",
                    min: 5,
                    message: "Введите корректное значение поля (минимум 5 символов)",
                    trigger: "change"
                },
                email: {
                  type: 'email',
                  message: 'Неверный формат email',
                  trigger: 'change'
                }

            }
        };
    };

    _app.computed.token = function () {
        return this.$store.state.access_token;
    };
    _app.computed.image_url_full = function() {
        return server_addr + this.formData.image_url;
    };

    // Загрузка и удаление картинки
    _app.methods.onSuccessImageUpload = function(response, filename) {
        // console.log(response);
        this.formData.image = response.filename;
        this.formData.image_url = response.url;
    };
    _app.methods.deleteImage = function() {
        this.formData.image = "";
        this.formData.image_url = "";
    };

    _app.computed.showChangePassword = function () {
        if (this.action === "edit") {
            return this.showEditPassword;
        } else {
            return false;
        }
    };

    _app.computed.showCreatePassword = function () {
        return (this.action === "create")
    };
    // Справочники
    // _app.methods.getStores = function() {
    //   const url = base_url + "/options/stores/";
    //   this.$http
    //     .get(url)
    //     .then(result => {
    //       this.formSelectOptions.stores = result.data.results;
    //     })
    //     .catch(error => {
    //       this.$Message.error("Ошибка получения списка счетов");
    //     });
    // };
    _app.methods.getCashes = function () {
        const url = base_url + "/options/cashes/";
        this.$http
            .get(url)
            .then(result => {
                this.formSelectOptions.cashes = result.data.results;
            })
            .catch(error => {
                this.$Message.error("Ошибка получения списка счетов");
            });
    };

    _app.watch["formData.cashier_code"] = function (newValue, oldValue) {
        this.validateForm();
        this.isChanged = true;
    };
    _app.watch["formData.max_amount"] = function (newValue, oldValue) {
        this.validateForm();
        this.isChanged = true;
    };
    _app.watch["formData.old_password"] = function (newValue, oldValue) {
      if (this.showChangePassword) {
        this.validateForm();
        this.isChanged = true;
      }
    };
   _app.watch["formData.new_password"] = function (newValue, oldValue) {
     if (this.showChangePassword) {
       this.validateForm();
       this.isChanged = true;
     }
    };

    _app.mounted = function () {
        // this.getStores();
        this.getCashes();
    };
    export default _app;
</script>

<style scoped>
  .left__col {
    border-right: 1px dashed rgba(14,37,74,0.3);
    padding-right: 40px;
  }

  .right__col {
    padding-left: 40px;
  }


  @media screen and (max-width: 767px) {
    .left__col {
      border-right: none;
      padding-right: 0;
    }
    .right__col {
      padding-left: 0;
    }

  }


</style>



// WEBPACK FOOTER //
// src/apps/user/userForm.vue